// src/components/register/RegistrationWizard/Steps/UserTypeStep.js
import React, { useState } from "react";
import { useRegistration } from "../../../../context/RegistrationContext";
import { toast } from "react-toastify";
import OpguruLogo from "../../../../assets/opgurulogo.png";
import { TailSpin } from "react-loader-spinner";

// Import images for user types
import StudentsImg from "../../../../assets/Students.png";
import ParentsImg from "../../../../assets/Parents.png";

// Import images for education levels
import SchoolImg from "../../../../assets/School.png";
import BachelorsImg from "../../../../assets/Bachelors.png";
import MastersImg from "../../../../assets/Masters.png";
import PhDImg from "../../../../assets/PhD.png";

const UserTypeStep = () => {
  const {
    userType,
    educationLevel,
    setField,
    nextStep,
    prevStep,
    validateStep,
    formErrors,
  } = useRegistration();

  const [loading, setLoading] = useState(false);

  // User type options
  const userTypes = [
    { id: 1, type: "Students", image: StudentsImg },
    { id: 2, type: "Parents", image: ParentsImg },
  ];

  // Education level options
  const educationLevels = [
    { id: 1, type: "11-12th", label: "11th-12th", image: SchoolImg },
    { id: 2, type: "Bachelors", label: "Bachelors", image: BachelorsImg },
    { id: 3, type: "Masters", label: "Masters", image: MastersImg },
    { id: 4, type: "PhD", label: "PhD", image: PhDImg },
  ];

  const handleUserTypeSelect = (type) => {
    setField('userType', type);
  };

  const handleEducationLevelSelect = (level) => {
    setField('educationLevel', level);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate the form
    if (!validateStep(3)) {
      toast.error("Please select all required options", {
        position: "top-center",
      });
      setLoading(false);
      return;
    }

    // Proceed to next step
    nextStep();
    setLoading(false);
  };

  return (
    <div className="step-container">
      <div className="auth-header">
        <div className="auth-title">Select User Type</div>
        <div className="auth-logo">
          <img src={OpguruLogo} alt="OpGuru Logo" />
        </div>
      </div>

      <div className="welcome-message">
        Please select your role and educational background
      </div>

      <form onSubmit={handleSubmit} className="registration-form">
        <div className="selection-section">
          <h3>I am a:</h3>
          <div className="card-selection">
            {userTypes.map((item) => (
              <div
                key={item.id}
                className={`selection-card ${userType === item.type ? 'selected' : ''}`}
                onClick={() => handleUserTypeSelect(item.type)}
              >
                <div className="card-image">
                  <img src={item.image} alt={item.type} />
                </div>
                <div className="card-label">{item.type}</div>
              </div>
            ))}
          </div>
          {formErrors.userType && (
            <div className="error-message">{formErrors.userType}</div>
          )}
        </div>

        {(userType === "Students" || userType === "Parents") && (
          <div className="selection-section">
            <h3>{userType === "Students" ? "My educational level:" : "My highest educational level:"}</h3>
            <div className="card-selection education-grid">
              {educationLevels.map((item) => (
                <div
                  key={item.id}
                  className={`selection-card ${educationLevel === item.type ? 'selected' : ''}`}
                  onClick={() => handleEducationLevelSelect(item.type)}
                >
                  <div className="card-image">
                    <img src={item.image} alt={item.type} />
                  </div>
                  <div className="card-label">{item.label}</div>
                </div>
              ))}
            </div>
            {formErrors.educationLevel && (
              <div className="error-message">{formErrors.educationLevel}</div>
            )}
          </div>
        )}

        <div className="button-group">
          <button
            type="button"
            className="secondary-button"
            onClick={prevStep}
          >
            Back
          </button>
          
          <button
            type="submit"
            className="primary-button"
            disabled={loading}
          >
            {loading ? (
              <TailSpin
                visible={true}
                height="24"
                width="24"
                color="#ffffff"
                ariaLabel="tail-spin-loading"
                radius="1"
              />
            ) : (
              "Next"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserTypeStep;